/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Json_Rest_Api_S4_TitleInputs */

const en_guide_json_rest_api_s4_title = /** @type {(inputs: Guide_Json_Rest_Api_S4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Debugging API Responses`)
};

const ko_guide_json_rest_api_s4_title = /** @type {(inputs: Guide_Json_Rest_Api_S4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API 응답 디버깅`)
};

const ja_guide_json_rest_api_s4_title = /** @type {(inputs: Guide_Json_Rest_Api_S4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`APIレスポンスのデバッグ`)
};

/**
* | output |
* | --- |
* | "Debugging API Responses" |
*
* @param {Guide_Json_Rest_Api_S4_TitleInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_json_rest_api_s4_title = /** @type {((inputs?: Guide_Json_Rest_Api_S4_TitleInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Json_Rest_Api_S4_TitleInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_json_rest_api_s4_title(inputs)
	if (locale === "ko") return ko_guide_json_rest_api_s4_title(inputs)
	return ja_guide_json_rest_api_s4_title(inputs)
});